import { CAMPAIGN as BASE } from "../route";

export const CUSTOMTAGS = BASE.sub("/customtags");
export const CUSTOMTAG = BASE.sub("/customtags/:customTagId");
